export enum MODULES {
    AMENDMENT = 'AMENDMENT',
    WORK_ORDER = 'WORK_ORDER'
}
export const PRODUCT_TYPE = ['BILLABLE', 'NON_BILLABLE', 'CONSUMABLE', 'RETURNABLE', 'COMPANY_ASSET'];
export enum PAGE_VIEW_TYPE {
    ADD = 'ADD',
    UPDATE = 'UPDATE',
    VIEW = 'VIEW'
}
export enum AMENDMENT_TYPE {
    AMENDMENT = 'Amendment',
    POST_APPROVAL = 'Post Approval Edit'
}
export enum TAX_CONVERT {
    TAX_CONVERT = 'Tax_Convert',
}